
import { ServiceWithSession } from './base-service';
import type { FormSession } from './form-session';
import type { GoogleAnalyticsOutcome } from '@cognitoforms/types/server-types/forms/model/google-analytics-outcome';

export default class AuditService extends ServiceWithSession {
	constructor(session: FormSession) {
		super(session);
	}

	recordGoogleAnalyticsOutcome(category: string, action: string, label: string, value: number, successful: boolean, auditLogId: string, auditRecordId: string) {
		const outcome: Partial<GoogleAnalyticsOutcome> = {
			Category: category,
			Action: action,
			Label: label,
			Value: value,
			Successful: successful,
			Timestamp: new Date().toUTCString()
		};
		return this.serviceRequest({
			method: 'POST',
			endpoint: 'svc/audit-log/' + auditLogId + '/record/' + auditRecordId + '/google-analytics-goal',
			data: outcome,
			isCognitoJson: true,
			headers: this.getValidationHeaders()
		});
	}
}